export const getAppStoreLogo = (locale: string) => {
  try {
    return require(`assets/images/store/app-store-${locale}.png`);
  } catch {
    return require('assets/images/store/app-store-en_gb.png');
  }
};

export const getGooglePlayLogo = (locale: string) => {
  try {
    return require(`assets/images/store/google-play-${locale}.png`);
  } catch {
    return require('assets/images/store/google-play-en_gb.png');
  }
};
